import Vue from 'vue'
import VueCookie from 'vue-cookie'
import App from './App.vue'

Vue.use(VueCookie);

new Vue({
  render: h => h(App)
}).$mount('#app')
